import { Component} from "@angular/core";

@Component({
    moduleId: module.id,
    selector: 'payment-redirect',
    templateUrl: 'paymentRedirect.component.html'
})
export class PaymentRedirectComponent {
    constructor() {
    }

}


// WEBPACK FOOTER //
// ./app/components/payment/paymentRedirect.component.ts